import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  id: "capabilities",
  class: "hm-section"
};
const _hoisted_2 = {
  class: "hm-container"
};
const _hoisted_3 = {
  class: "cap-grid"
};
const _hoisted_4 = {
  class: "cap-top"
};
const _hoisted_5 = {
  class: "cap-index"
};
const _hoisted_6 = {
  class: "cap-visual",
  "aria-hidden": "true"
};
const _hoisted_7 = {
  key: 0,
  class: "cap-wave",
  viewBox: "0 0 200 60",
  preserveAspectRatio: "none"
};
const _hoisted_8 = {
  key: 1,
  class: "cap-bars"
};
const _hoisted_9 = {
  key: 2,
  class: "cap-eq"
};
const _hoisted_10 = {
  key: 3,
  class: "cap-ring",
  viewBox: "0 0 60 60"
};
const _hoisted_11 = {
  class: "cap-title"
};
const _hoisted_12 = {
  class: "cap-text"
};
const _hoisted_13 = {
  class: "cap-points"
};
const _hoisted_14 = {
  class: "cap-loop",
  role: "list",
  "aria-label": "睡眠闭环流程"
};
const _hoisted_15 = {
  class: "cap-loop__node",
  role: "listitem"
};
const _hoisted_16 = {
  key: 0,
  class: "cap-loop__line",
  "aria-hidden": "true"
};
export default {
  __name: 'HomeCapabilities',
  setup(__props) {
    const capabilities = [{
      key: 'sense',
      title: '脑电感知',
      desc: '头戴设备贴合前额采集单通道脑电，主动读取，戴着就能入睡。',
      points: ['NeuroSky TGAM 芯片方案', '512Hz 采样率', ' 连续 8 小时']
    }, {
      key: 'analyze',
      title: '状态识别',
      desc: '以单通道脑电为输入，识别入睡、浅睡、深睡等状态变化，为后续干预提供依据。',
      points: ['深度学习状态识别模型', '已申请 2 项发明专利', '端侧 + 云端协同判断']
    }, {
      key: 'intervene',
      title: '音频干预',
      desc: '枕头内置的微型喇叭按当前状态播放对应音频，音量与内容随睡眠阶段调整。',
      points: ['嵌入式双声道喇叭', '音频延迟低于 50ms', '无需佩戴耳机']
    }, {
      key: 'feedback',
      title: '数据反馈',
      desc: '每晚数据回流到 App，形成可读的睡眠报告，让改善过程看得见、可对比。',
      points: ['睡眠状态趋势报告', '音频推送记录', '持续更新个人模型']
    }];
    const stageBars = [34, 62, 88, 54, 40];
    const loopSteps = ['感知', '识别', '干预', '反馈'];
    const indexLabel = index => String(index + 1).padStart(2, '0');

    /* 卡片内的跟随高光：把鼠标位置写进 CSS 变量，交给 ::after 画径向渐变 */
    const moveSpotlight = event => {
      const el = event.currentTarget;
      const rect = el.getBoundingClientRect();
      el.style.setProperty('--mx', `${event.clientX - rect.left}px`);
      el.style.setProperty('--my', `${event.clientY - rect.top}px`);
    };
    return (_ctx, _cache) => {
      const _directive_reveal = _resolveDirective("reveal");
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[2] || (_cache[2] = _createElementVNode("header", {
        class: "hm-head"
      }, [_createElementVNode("div", null, [_createElementVNode("h2", {
        class: "hm-title"
      }, [_createTextVNode("从一次脑电采集，"), _createElementVNode("br"), _createTextVNode("到一夜好眠的闭环")])]), _createElementVNode("p", {
        class: "hm-desc"
      }, " 感知、识别、干预、反馈四步都运行在同一套系统里：设备只负责采集，判断与推送由端侧算法与云端模型协同完成，用户不需要理解任何参数。 ")], -1)), _createElementVNode("ol", _hoisted_3, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(capabilities, (item, index) => {
        return _withDirectives(_createElementVNode("li", {
          key: item.key,
          class: "cap-card",
          onMousemove: moveSpotlight
        }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(indexLabel(index)), 1), _createElementVNode("div", _hoisted_6, [item.key === 'sense' ? (_openBlock(), _createElementBlock("svg", _hoisted_7, _cache[0] || (_cache[0] = [_createElementVNode("path", {
          d: "M0 30 C8 30 12 30 18 28 C24 26 28 34 34 32 C40 30 44 22 50 24 C56 26 60 40 66 38 C72 36 76 18 82 20 C88 22 92 34 98 32 C104 30 108 24 114 26 C120 28 124 36 130 34 C136 32 140 22 146 24 C152 26 156 32 162 30 C168 28 172 24 178 26 C184 28 190 30 200 30"
        }, null, -1)]))) : item.key === 'analyze' ? (_openBlock(), _createElementBlock("span", _hoisted_8, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(stageBars, (h, i) => {
          return _createElementVNode("i", {
            key: i,
            class: "cap-bar",
            style: _normalizeStyle({
              height: `${h}%`
            })
          }, null, 4);
        }), 64))])) : item.key === 'intervene' ? (_openBlock(), _createElementBlock("span", _hoisted_9, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, n => {
          return _createElementVNode("i", {
            key: n,
            class: "cap-eq__bar",
            style: _normalizeStyle({
              animationDelay: `${n * 90}ms`
            })
          }, null, 4);
        }), 64))])) : (_openBlock(), _createElementBlock("svg", _hoisted_10, _cache[1] || (_cache[1] = [_createElementVNode("circle", {
          class: "cap-ring__track",
          cx: "30",
          cy: "30",
          r: "23",
          transform: "rotate(-90 30 30)"
        }, null, -1), _createElementVNode("circle", {
          class: "cap-ring__value",
          cx: "30",
          cy: "30",
          r: "23",
          transform: "rotate(-90 30 30)"
        }, null, -1), _createElementVNode("text", {
          class: "cap-ring__text",
          x: "30",
          y: "34"
        }, "每晚", -1)])))])]), _createElementVNode("h3", _hoisted_11, _toDisplayString(item.title), 1), _createElementVNode("p", _hoisted_12, _toDisplayString(item.desc), 1), _createElementVNode("ul", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.points, point => {
          return _openBlock(), _createElementBlock("li", {
            key: point
          }, _toDisplayString(point), 1);
        }), 128))])], 32), [[_directive_reveal, index * 90]]);
      }), 64))]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(loopSteps, (step, index) => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: step
        }, [_createElementVNode("span", _hoisted_15, [_createElementVNode("i", {
          class: "cap-loop__dot",
          style: _normalizeStyle({
            animationDelay: `${index * 420}ms`
          }),
          "aria-hidden": "true"
        }, null, 4), _createElementVNode("b", null, _toDisplayString(step), 1)]), index < loopSteps.length - 1 ? (_openBlock(), _createElementBlock("span", _hoisted_16)) : _createCommentVNode("", true)], 64);
      }), 64))])), [[_directive_reveal]])])]);
    };
  }
};